export const WEBSITES_API = "/api/v1/websites";

export function sitePath(siteId, suffix = "") {
  return `${WEBSITES_API}/sites/${siteId}${suffix}`;
}

export function formatApiError(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg || item?.message || String(item)).join("; ");
  }
  if (detail && typeof detail === "object") return detail.message || fallback;
  return detail || fallback;
}

// The backend owns domain state; never send it through PATCH /sites/{id}.
export function withoutDomainSettings(settings = {}) {
  return Object.fromEntries(Object.entries(settings || {}).filter(([key]) => !key.startsWith("domain")));
}

export function siteHostname(site, domain) {
  return domain?.platform_hostname || site?.settings?.dns_target || "";
}

export function sitePublicUrl(site, domain) {
  if (domain?.domain && domain?.status === "active") return `https://${domain.domain}`;
  if (site?.settings?.platform_url) return site.settings.platform_url;
  const host = siteHostname(site, domain);
  return host ? `https://${host}` : "";
}

export function resolvePublicAsset(path) {
  if (!path) return "";
  if (/^(https?:)?\/\//.test(path) || path.startsWith("data:")) return path;
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
}
